<template>
	<div
		class="home"
		ref="home"
	>
		<!-- <img
			class="design"
			src="../assets/design.jpg"
			alt=""
		> -->
		<Arrow
			v-if="curpage<2"
			@click="goNext"
			class="arrow"
		></Arrow>
		<Arrow
			v-if="curpage==2"
			@click="goPrev"
			class="arrow_left"
		></Arrow>
		<div
			class="bg_wrap"
			ref="bg_wrap"
		>
			<div
				ref="background"
				class="background"
			>
				<div class="huxi">
					<img
						class="bg"
						src="../assets/background01.jpg"
					>
					<img
						class="bg"
						src="../assets/background02.jpg"
					>
				</div>

				<img
					ref="buildding"
					class="buildding shan"
					src="../assets/building.png"
					alt=""
				>
			</div>

		</div>

		<div class="page page1">

			<div
				class="logo animation"
				data-out="slideOutLeft"
				data-duration="1000"
			>
				<span
					class="chengdu animation"
					data-name="slideInRight"
					data-duration="1000"
				></span>
				<span
					class="xiecheng animation"
					data-name="slideInRight"
					data-duration="1000"
					data-delay="200"
				></span>
			</div>
			<div
				class="slogan_wrap animation"
				data-out="zoomOut"
				data-duration="1000"
			>
				<div
					class="slogan_big "
					ref="slogan_big"
				>
					<span
						class="animation"
						data-name="bounceIn"
						data-duration="600"
						data-delay="0"
					></span>
					<span
						class="animation"
						data-name="bounceIn"
						data-duration="600"
						data-delay="100"
					></span>
					<span
						class="animation"
						data-name="bounceIn"
						data-duration="600"
						data-delay="200"
					></span>
					<span
						class="animation"
						data-name="bounceIn"
						data-duration="600"
						data-delay="300"
					></span>
					<span
						class="animation"
						data-name="bounceIn"
						data-duration="600"
						data-delay="400"
					></span>
					<span
						class="animation"
						data-name="bounceIn"
						data-duration="600"
						data-delay="500"
					></span>
				</div>
				<span
					class="slogan_small animation"
					data-name="fadeInUp"
					data-duration="600"
					data-delay="600"
				></span>
			</div>
		</div>
		<div class="page page2">
			<div
				class="chengdu_wrap animation"
				data-name="slideInRight"
        data-easing="ease-out"
				data-out="zoomOut"
				data-duration="1000"
			>
				<!-- <span class="light light1 shan"></span>
				<span class="light light2 shan"></span> -->
				<h2
					class="title"
					data-name="slideInUp"
          data-delay="100"
					data-duration="600"
				></h2>
				<div class="inner article_wrap">
					<h4> 成都旅游魅力无穷</h4>
					<p>成都，是中华文明的重要发源地之一，远在 4500 年前，就已经产生了中华文明源头的新石器时代晚期文化——“宝墩文化”，这是中国长江流域辉煌上古文明的缩影。成都自古商埠繁荣，有“扬一益二”之说，拥有青城山—都江堰世界文化遗产、大熊猫栖息地世界自然遗产，是威尼斯商人马可·波罗心目中的“强大都市”，是法国旅行家古德尔孟赞叹的“东方巴黎”，也是南北“丝绸之路”的起点。由于商业发达，在公元 1023 年，成都出现了世界上最早的纸币“交子”。成都，外揽山水之幽，内得人文之胜，是联合国教科文组织主办的世界非物质文化遗产节永久举办城市，是世界银行发布的中国内陆投资环境标杆城市，是联合国教科文组织公布的世界美食之都，是联合国世界旅游组织和中国国家旅游局联合命名的中国最佳旅游城市。</p>
					<h4>成都旅游势头良好</h4>
					<p>作为中国西部特大中心城市，成都经济社会保持良好发展势头，城市综合实力不断攀升，国际影响力不断增强。<font class="stress">2019年成都加快建设“三城三都”，取得明显成效，现有规上文创企业2100余家，预计全年实现文创产业增加值1350亿元；预计全年实现旅游总收入4650亿元、增长约25%。</font>被国家旅游局评为“中国旅游休闲示范城市”；被全球第一旅游评论网站 Tripadvisor 评为“中国最受全球旅客欢迎的 10 大旅游目的地”；万事达卡国际组织“全球旅游目的地城市指数”评选，成都旅游增长活力连续 2 年排位全球第二。同时，作为中国西部对外交往中心，美国、德国、法国等 17 个国家在蓉设立领事机构，国际友城和友好合作城市 89 个，开通国际（地区）航线 109条，成为内地第三个拥有双机场的城市，是中国中西部第一个实施 144 小时过境免签政策的城市，国际交往便利度和对外交流合作紧密度不断提升。</p>

					<h4>成都旅游商机无限</h4>
					<p>目前，成都以建设全面体现新发展理念城市为战略目标，全力塑造“三城三都”城市品牌，对标国际其他世界旅游名城，围绕独具特色的天府文化，突出旅游特色化、品牌化、国际化发展，逐步建成对接国际市场、具有中国典范、独具东方休闲神韵的世界旅游名城和亚太地区旅游枢纽港。</p>

					<h4>优选旅游项目</h4>
					<h5>【天府绿道项目】</h5>
					<p>按照建设大生态、构筑新格局的思路，成都规划构建城市三级慢行系统，厚植城市自然人文环境，提升市民宜居生活品质，以“可进入、可参与、景观化、景区化”的规划理念，以人民为中心、以绿道为主线、以生态为本底、以田园为基调、以文化为特色，全域规划形成“一轴两山三环七带”的区域级绿道1920 公 里、城区级绿道5000公里以上、社 区 级绿道 10000 公里以上。</p>

					<h5>【成都龙泉山城市森林公园项目】</h5>
					<p>龙泉山的总体定位为“世界级品质的城市绿心，国际化的城市会客厅”，将重点打造大云顶康养生态度假区、五洛文创休闲旅游带、天府生态博览园、国 际 IP 主 题 乐 园 四 个 引擎旅游项目，建设集“山地运动、山水度假、城市休闲”于一体的中国首个城市中央大型生态休闲公园、国际知名的全景山地休闲旅游目的地。</p>

					<h5>【乡村旅游项目】</h5>
					<p>围绕乡村振兴战略，将建设以文化体验、康养度假为主要特色的沿龙门山、环龙泉山、环都市区乡村旅游带；以生态观光、郊野游憩为主要特色的“三环七带”天府绿道旅游带；打造以民俗体验、田园休闲为主要特色的都江堰精华灌区旅游群和以山水运动、自驾露营为主要特色的龙门山、邛崃山系旅游区。</p>

					<p>除以上项目外，我市还有川西林盘、旅游产业功能区、旅游特色小镇、旅游融合新业态等精品项目。请积极参阅成都市精选旅游项目招商手册 , 欢迎您到项目点位实地考察，磋商洽谈，共谋合作，争取早日成为成都旅游产业发展的参与者和受益者。</p>

				</div>
				<span class="xiongmao"></span>
				<a
					class="zszc_btn"
					@click="showPopup"
					href="javascript:void(0)"
				> <span>成都投资政策</span> </a>
			</div>
		</div>
		<div class="page page3">
			<div
				class="map animation"
				data-name="zoomIn"
				data-out="zoomOut"
				data-duration="800"
				replace
			>
				<Map ref="map"></Map>

			</div>

		</div>
		<div
			class="popup_wrapper"
			ref="popup_wrapper"
		>
			<div
				class="popup_outer"
				ref="popup_outer"
			></div>
			<div
				class="project_popup"
				ref="popup"
			>
				<h3>成都投资政策</h3>
				<a
					class="close"
					href="javascript:void(0)"
				></a>
				<div class="text_wrap article_wrap">
					<img
						src="../assets/image1.png"
						alt=""
					>
					<h4>优惠政策</h4>
					<p>为促进文旅产业发展，成都市出台《成都市建设世界旅游名城三年行动计划》《成都市促进旅游业改革发展若干政策措施》《关于大力推动文化商贸旅游体育融合发展的实施意见》《关于促进民宿业健康发展的指导意见》等相关扶持政策 13 个，其中涉及对酒店业奖补、用地等相关优惠条件。各区（市）县均配套了促进文旅产业发展的相关扶持政策，对于投资建设酒店给予 30万元到 200 万元不等的奖补，对新评定的五星级、四星级、三星级乡村酒店、农家乐分别给予一次性奖励 50万元、30 万元、10 万元，按照对地方经济的贡献给予50% 以上的奖励等优惠条件。</p>

					<h4>应对疫情影响开展的工作</h4>
					<p>为应对新冠肺炎疫情影响，成都市出台《关于应对新冠肺炎疫情影响促进文化旅游业健康发展的若干措施》印发《成都市发展周末文化旅游经济促进国际消费中心城市建设实施方案》《成都市促进旅游业加快恢复发展的政策措施》等一系列政策文件。编制成都音乐影视地图，依托新媒体重点推介一批潮流音乐消费点位和精品旅游点位，激发周末、夜间文旅消费潜力。开展文旅行业“送政策、帮企业、送服务、解难题”专项行动，组建专班深入企业和行业协会，协调解决困难和问题。迅速启动 2020 年市级旅游业发展专项资金、文产专项资金（音乐产业）申报扶持工作，安排文产旅产资金 2000 万元发放电子消费券、1600 万元用于文旅企业疫情纾困、4000 万元用于支持旅游包机、专列。市级财政安排 2 亿元用于提振消费。</p>

					<h4>文旅（运动）产业功能区情况</h4>
					<p>为进一步提升产业能级、增强极核功能，更好发挥优势带动、辐射引领作用，避免区域同质化竞争，构筑城市比较优势的战略选择，发挥优势产业集聚效应，实现全域旅游格局，成都市明确了 14 个产业生态圈，其中文旅（运动）产业生态圈包括 15 个产业功能区，依托其自身资源禀赋、区位优势和发展基础，统筹发展主导产业、细分领域，形成了“1 圈 2 板块 11 域 15 区”的错位协同发展布局。15 个产业功能区各明确1-2 个主导产业方向，文创板块聚力发展传媒影视、创意设计、音乐艺术、动漫游戏、会展广告、数字娱乐6 大领域；旅游运动板块重点发展文化旅游、康养度假、生态旅游、冰雪运动、山水休闲 5 大领域，衍生发展旅游出行、旅游住宿、旅游餐饮、旅游游览、旅游购物、旅游娱乐、旅游综合服务 7 个业态。</p>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
// import Map from "../components/Map";
import Touch from "ztgamejs/touch";
import Animate from "ztgamejs/css3animate";
import AnimateCss from "../libs/animatecss";
import Arrow from "../components/Arrow";
import Map from "../components/Map";

import Popup from "ztgamejs/gpopup";
export default {
	name: "Home",
	components: {
		Arrow,
		Map,
	},
	data() {
		return {
			curpage: -1,
		};
  },
  activated(){
    this.goTo(this.curpage);
  },
	mounted() {
		$(window).resize(() => {
			this.setBackground();
		});
		this.setBackground();
		this.bindTouch();
		var initpage = 0;
		if (this.$route.params.page) {
			initpage = this.$route.params.page;
		}
		this.goTo(initpage);
		this.popup = new Popup(this.$refs.popup, {
			scrollObj: null,
			startShow: () => {
				$(this.$refs.popup_outer).show();
				$(this.$refs.popup_wrapper).css({ top: 0 });
			},
			endHide: () => {
				$(this.$refs.popup_outer).hide();
				$(this.$refs.popup_wrapper).css({ top: "-1000%" });
			},
		});
	},
	methods: {
		showPopup() {
			this.popup.show(this.$refs.popup);
		},
		goNext() {
			this.goTo(this.curpage + 1);
		},
		goPrev() {
			this.goTo(this.curpage - 1);
		},
		bindTouch() {
			let changed = false;
			new Touch(this.$refs.home, {
				start: (pos, e) => {
					changed = false;
				},
				move: (delta, e) => {
					if (changed) {
						return;
					}
					var realX = window.curAngle != 0 ? delta.y : delta.x;
					if (realX < -100) {
						this.goTo(this.curpage + 1);
						changed = true;
					} else if (realX > 100) {
						this.goTo(this.curpage - 1);
						changed = true;
					}
				},
				end: (delta, e) => {},
			});
		},

		setBackground() {
			if (!window.winSize) {
				return;
			}
			var offset = (window.winSize[0] - (4870 * SCALE) / 3) / 2;
			if (offset > 0) {
				this.$refs.buildding.style.marginLeft = offset + "px";
				offset = 0;
			}
			this.$refs.background.style.marginLeft = offset + "px";
		},
		goTo(pageIndex) {
			if (pageIndex >= $(".page").length) {
				return;
			} else if (pageIndex < 0) {
				return;
			}
			var nextPage = $(".page").eq(pageIndex);
			var delay = 0;
			var curPage = null;
			if (this.curpage >= 0&&this.curpage!=pageIndex) {
				curPage = $(".page").eq(this.curpage);
				AnimateCss.stop(curPage);
				AnimateCss.out(curPage);
				delay = 600;
			}
      var x = -100 * pageIndex;
      var onscreenWidth = $(window).width()/window.SCALE;
      var maxbili = -(4750/onscreenWidth-1)*100;
      // alert(onscreenWidth);
      // alert(maxbili);
      if(x<maxbili){
        x=maxbili;
      }
			// if (pageIndex == 2) {
			// 	x = -150;
			// }
			Animate.to(
				this.$refs.background,
				{
					x: x + "%",
				},
				1200,
				"ease-in-out"
			);
			setTimeout(() => {
				nextPage.show();
				AnimateCss.stop(nextPage);
				AnimateCss.run(nextPage);
				if (curPage) {
					AnimateCss.stop(curPage);
					curPage.hide();
				}
				this.curpage = pageIndex;
				if (pageIndex == 2) {
					this.$refs.map.reset();
				}
			}, delay);
		},
	},
	watch: {
		// curpage(newVal, oldVal) {
		// 	if (newVal > $(".page").length - 1) {
		// 		this.curpage = oldVal;
		// 	} else if (newVal < 0) {
		// 		this.curpage = oldVal;
		// 	}
		// 	this.goTo(newVal);
		// },
	},
};
</script>
<style scoped lang="less">
.design {
	height: 100%;
	left: 0;
	position: absolute;
	left: 0;
}
.bg_wrap {
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
}
.background {
	height: 100%;
	width: 100%;
	// background: url("../assets/background.jpg") no-repeat center/cover;
	.huxi {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: visible;
		white-space: nowrap;
		font-size: 0;
	}

	.bg {
		height: 100%;
		vertical-align: top;
	}
}
.buildding {
	width: 15.62rem;
	position: absolute;
	bottom: 0;
	left: 0.1rem;
	transform: translateZ(10px);
}
.home {
	position: relative;
	width: 100%;
	height: 100%;
	/* display: flex;
	flex-direction: row; */
}
.page {
	width: 100%;
	height: 100%;
	position: absolute;
	flex-shrink: 0;
	left: 0;
	top: 0;
	display: none;
	transform: translateZ(10px);
}
.logo {
	left: 0;
	top: 0;
	position: absolute;
	left: 0.2rem;
	top: 0.4rem;
	padding-left: constant(safe-area-inset-left);
	padding-left: env(safe-area-inset-left);
}
.chengdu {
	display: inline-block;
	width: 1.56rem;
	height: 0.51rem;
	background: url("../assets/chengdu.png") no-repeat center / contain;
}
.xiecheng {
	display: inline-block;
	width: 1.68rem;
	height: 0.42rem;
	background: url("../assets/xiecheng.png") no-repeat center / contain;
	margin-left: 0.2rem;
}
.slogan_wrap {
	text-align: center;
	.slogan_big {
		margin: 1.9rem auto 0;
		width: 7.24rem;
		height: 1.2rem;

		span {
			width: 16.666%;
			display: inline-block;
			height: 100%;
			background: url("../assets/slogan.png") no-repeat left/7.24rem
				1.2rem;
		}
		span:nth-child(2) {
			background-position: 19.66% 0;
		}
		span:nth-child(3) {
			background-position: 39.66% 0;
		}
		span:nth-child(4) {
			background-position: 59.66% 0;
		}
		span:nth-child(5) {
			background-position: 80.66% 0;
		}
		span:nth-child(6) {
			background-position: 100.66% 0;
		}
	}
	.slogan_small {
		width: 6.32rem;
		height: 1.16rem;
		background: url("../assets/small_slogan.png") no-repeat center/contain;
		display: inline-block;
	}
}

.page2 {
	.chengdu_wrap {
		width: 12.5rem;
		height: 5.8rem;
		background: url("../assets/info_bg.png") no-repeat center/100% 100%;
		margin: 0 auto;
		color: #4ebeff;
		overflow: visible;
		position: relative;
		top: 50%;
    
		margin-top: -2.9rem;
		.title {
			height: 1rem;
			background: url("../assets/cdjj.png") no-repeat center/contain;
			position: relative;
			width: 100%;
			top: -0.3rem;
		}
		.inner {
			position: relative;
			z-index: 10;
			width: 9.9rem;
			margin: 0 auto;
			text-align: left;
			// line-height: 0.36rem;
			// font-size: 0.2rem;
			height: 3.3rem;
			overflow: auto;
			margin-top: 0.3rem;
			p {
				// font-size: 0.2rem !important;
			}
			.fenduan {
				margin-top: 0.3rem;
			}
		}
		.xiongmao {
			display: inline-block;
			width: 1.82rem;
			height: 1.94rem;
			background: url("../assets/xiongmao.png") no-repeat center/contain;
			position: absolute;
			right: 1rem;
			bottom: 1rem;
		}
		.light {
			display: inline-block;
			width: 0.93rem;
			height: 3.16rem;
			position: absolute;
			top: 1.4rem;
		}
		.light2 {
			background: url("../assets/light1.png") no-repeat center/contain;
			right: -0.2rem;
		}
		.light1 {
			background: url("../assets/light2.png") no-repeat center/contain;
			left: -0.3rem;
		}
	}
}

.page3 {
	a {
		display: block;
		position: relative;
		width: 100%;
		height: 100%;
	}
	.map {
		// height: 120%;
		// position: relative;
		// top: -10%;
		// display: block;
		// margin: 0 auto;
		margin: -0.25rem auto 0;
		width: 8rem;
		height: 8rem;
		position: relative;
	}
}
// .page1 {
// 	display: block;
// }

.arrow {
	position: absolute;
	right: 0.6rem;
	margin-right: constant(safe-area-inset-right);
	margin-right: env(safe-area-inset-right);
	top: 50%;
	z-index: 10;
	margin-top: -0.28rem;
}
.arrow_left {
	position: absolute;
	left: 0.6rem;
	margin-left: constant(safe-area-inset-left);
	margin-left: env(safe-area-inset-left);
	top: 50%;
	z-index: 10;
	margin-top: -0.28rem;
	transform-origin: 50% 50%;
	transform: rotate(-180deg);
}
.shan {
	animation: shan 2s ease-in-out 0s infinite alternate-reverse both;
}
@keyframes shan {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0.8;
	}
}

// .shan {
// 	animation: zhiwend 1s linear infinite alternate both;
// }
</style>

<style lang="less" scoped>
.zszc_btn {
	position: absolute;
	width: 2.84rem;
	height: 0.47rem;
	line-height: 0.47rem;
	bottom: 0.3rem;
	left: 50%;
	margin-left: -1.6rem;
	display: block;
	text-align: center;
  color: #fff;
  font-size: 0.22rem;
	span {
		vertical-align: middle;
	}
	&::before {
		margin-top: -0.08rem;
		content: "";
		display: inline-block;
		width: 0.43rem;
		height: 0.51rem;
		background: url("../assets/arrow_right.png") no-repeat center/contain;
		// font-size: 0.18rem;
		// color: #fff;
		vertical-align: middle;
		animation: moveright 1s ease-in 0s infinite alternate-reverse both;
	}
}

.popup_wrapper {
	transform: translateZ(10px);
	position: absolute;
	left: 0;
	top: -1000%;
	width: 100%;
	height: 100%;
	z-index: 1000;
}
.popup_outer {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.9);
	position: absolute;
	left: 0;
	top: 0;
	z-index: 2000;
	display: none;
}
.project_popup {
	display: none;
	position: relative;
	width: 9.75rem;
	height: 5.96rem;
	background: url("../assets/popup_bg.png") no-repeat center/contain;
	overflow: visible;

	& > h3 {
		text-align: center;
		font-size: 0.4rem;
		position: relative;
		top: -0.1rem;
		text-shadow: 0px 0px 5px #056ee1;
		// margin-top: -0.1rem;
	}
	.close {
		position: absolute;
		right: 0rem;
		top: 0.1rem;
		width: 0.6rem;
		height: 0.6rem;
	}
	& > .text_wrap {
		text-align: left;
		-webkit-overflow-scrolling: touch;
		width: 8.1rem;
		height: 3.66rem;
		margin: 0.8rem auto 0;
		line-height: 1.6;
		overflow: auto;
		// padding-left: 0.2rem;
		// & > h4:first-child{
		//   margin-top:0 ;
		// }
		// & > h4 {
		// 	position: relative;
		// 	margin: 0.2rem 0;
		// 	font-size: 0.16rem;
		// 	&::before {
		// 		content: "";
		// 		display: inline-block;
		// 		width: 0.05rem;
		// 		height: 0.05rem;
		// 		background: #00e7ff;
		// 		border-radius: 0.025rem;
		// 		position: absolute;
		// 		left: -0.2rem;
		// 		top: 50%;
		// 		margin-top: -0.025rem;
		// 	}
		// }
		// & > p {
		// 	color: #1273ca;
		// 	font-size: 0.14rem;
		// }
	}
}
</style>
